<!--
THIS IS THE VUE3 VERSION OF THIS COMPONENT.
For the Vue2 version, see:
../../../../js/components/RotationalBanner/ToyotaRotationalbanners.vue
============================================\

-->

<template>
  <div class="rotational-banner-component primary-rotational-banner cam-rotational-banner">
    <div
      v-if="bannersdata.length"
      id="rotaional-carousel"
      :data-count="vehicleCount"
      class="rotational-banners position-relative"
    >
      <SlickCarousel
        :config="carouselConfigObject"
        :slot-ids="slotIds"
        @slideChange="onSlideChange"
      >
        <template v-for="(banner, index) in bannersdata" v-slot:[`slide-${banner.bannerId}`]>
          <div v-if="findBannerType(banner)" :key="banner.bannerId" class="h-100">
            <a
              v-if="baseUrl + banner.url"
              class="d-block position-relative banner-wrapper cursor-pointer"
              @click.prevent="openBindEvent(banner)"
            >
              <LazyImageWrapper
                v-if="!ismobile && banner.imageUrl"
                :src="getImageSourceUrl(banner)"
                :loading="banner.imageUrl + '&type=webp&quality=6'"
                :classes="'w-100 set-aspect-ratio'"
                :alt="banner.altText"
              />
              <template v-if="ismobile && banner.mobileImageUrl">
                <LazyImageWrapper
                  v-if="websitesDomain && isLandingPage && applySpeedValues"
                  :src="getMobileImageUrl(banner.mobileImageUrl, banner)"
                  :classes="'set-aspect-ratio'"
                  :width="deviceWidth"
                  :height="deviceHeight"
                  :alt="banner.altText"
                />
                <LazyImageWrapper
                  v-else
                  :src="getImageSourceUrlMobile(banner)"
                  :classes="'set-aspect-ratio w-100'"
                  :alt="banner.altText"
                />
              </template>
            </a>
          </div>
          <div v-else :key="`${banner.bannerId}`" class="h-100">
            <a
              v-if="baseUrl + banner.url"
              class="d-block position-relative banner-wrapper cursor-pointer"
              :style="[setClassForAutoBanner(banner)]"
              @click.prevent="openBindEvent(banner)"
            >
              <template v-if="getBannerBgType(banner)">
                <LazyImageWrapper
                  v-if="!ismobile && banner.imageUrl"
                  :src="banner.imageUrl + `&type=webp&quality=${bannerQuality}`"
                  :loading="banner.imageUrl + '&type=webp&quality=6'"
                  :classes="'w-100 set-aspect-ratio'"
                  :alt="banner.altText"
                />
                <template v-if="ismobile && banner.mobileImageUrl">
                  <LazyImageWrapper
                    v-if="websitesDomain && isLandingPage && applySpeedValues"
                    :src="getMobileImageUrl(banner.mobileImageUrl)"
                    :classes="'set-aspect-ratio'"
                    :width="deviceWidth"
                    :height="deviceHeight"
                    :alt="banner.altText"
                  />
                  <LazyImageWrapper
                    v-else
                    :src="banner.mobileImageUrl + '&type=webp&quality=95'"
                    :classes="'set-aspect-ratio w-100'"
                    :alt="banner.altText"
                  />
                </template>
              </template>

              <evox-media-rotational-banner
                v-if="
                  banner.rotationalBannerType &&
                  banner.rotationalBannerType.toLowerCase() !== 'image'
                "
                :bannerdata="banner"
                :callForPriceDetails="callForPriceDetails"
                :class="[render, noBannerWithBgImage ? 'noBannerWithBgImage' : '']"
                @show-Offer-Disclaimer="openDisclaimer"
              />
            </a>
          </div>
        </template>
      </SlickCarousel>
      <a
        v-if="checkDisclaimer()"
        id="btn-details"
        style="position: absolute; z-index: 7"
        class="banner-view-details bgcolor-primary font-weight-bold _msbi_background_color px-1 px-sm-2 no-hover text-center py-1 py-sm-2 position-absolute text-white rounded-buttons btn-websites button-primary cursor-pointer"
        :class="[
          hidecontrols !== 'True' ? 'test' : 'hide-controls-enabled',
          getDisclaimerPosition(),
        ]"
        @click.prevent="onDisclaimerClick()"
      >
        <i
          :class="[
            getDisclaimerPosition() === 'banner-view-details-top' ? '' : 'primaryicon-info',
            'mr-1 mr-sm-2',
          ]"
          aria-hidden="true"
        />{{ getDisclaimerLabel() }}
      </a>
    </div>
  </div>
</template>

<script>
import SlickCarousel from "../.../../../Shared/SlickCarousel/SlickCarousel.vue";
import LazyImageWrapper from "../../Shared/LazyImageWrapper/LazyImageWrapper.vue";

import { TagManagerContainer } from "../../../Events/GoogleTagManager/TagManagerContainer";

import axios from "axios";
import ShiftDigitalContainer from "../../../Events/ShiftDigital/ShiftDigitalContainer";
import ShiftDigitalService from "../../../Events/ShiftDigital/ShiftDigitalService";
import { SHIFT_DIGITAL_IMAGE_ROTATIONAL_CAROUSEL_ASSET_NAME } from "@/js/services/ShiftDigital/ShiftDigitalConstants";
import { fireSonicCarouselBannerClick } from "../../../Events/SonicDataLayer/SonicDataService";
import { fireTagMediaInteractionEvent } from "../../../Events/TagManagerServices/TaggingEventForPages";

import EvoxMediaRotationalBanner from "../../EvoxMediaRotationalBanner/EvoxMediaRotationalBanner.vue";
import { LayoutConstants } from "@/js/constants/LayoutConstants";
import RotationalBannerMixin from "@/js/components/RotationalBanner/RotationalBannerMixin";
import { onModalLinkClick } from "@/js/services/CommonUtility";
import { useBannersDataStore } from "../../../store/BannersDataStore/BannersDataStore";
import { useTextModalStore } from "../../../store/Shared/TextModalStore/TextModalStore";
import { useBuyNowModalStore } from "../../../store/Shared/BuyNowModalStore/BuyNowModalStore";
import { mapWritableState } from "pinia";
export default {
  components: {
    SlickCarousel,
    LazyImageWrapper,

    EvoxMediaRotationalBanner,
  },
  mixins: [RotationalBannerMixin],
  props: {
    sectionid: {
      required: true,
    },
    banners: {
      required: false,
      default: "",
    },
    hidearrows: {
      required: false,
      default: false,
    },
    hidecontrols: {
      required: false,
      default: false,
    },
    render: {
      required: false,
      default: "",
      type: String,
    },
    nextArrowIcon: {
      required: false,
      default: "",
      type: String,
    },
    previousArrowIcon: {
      required: false,
      default: "",
      type: String,
    },
    applySpeedValues: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      slotIds: [],
      carouselConfigObject: {
        wrapAround: true,
        itemsToShow: 1,
        autoplay: 0
      },
      showdisclaimermodal: false,
      disclaimerLabel: " Disclosure",
      disclaimertext: "",
      shiftDigital: "",
      currentSlide: 0,
      slide: 0,
      sliding: null,
      searchtype: "new",
      searchkey: "",
      baseUrl: window.baseUrl,
      bannersdata: [],
      searchdata: "",
      vehiclesdata: [],
      ismobile: window.ismobile,
      // bannerTimmer: 0,
      // bannerautoplay: false,
      buyNowPopType: "new",
      deviceWidth: "100%",
      deviceHeight: "auto",
      isLandingPage: window.location.pathname === "/",
      websitesDomain: typeof window.websitesDomain !== "undefined" ? window.websitesDomain : false,
      callForPriceDetails: [],
    };
  },
  computed: {
    vehicleCount() {
      return this.bannersdata ? this.bannersdata.length : 0;
    },
    ...mapWritableState(useBannersDataStore, {
      rotationalBannersData: "rotationalBannersData",
    }),
    ...mapWritableState(useTextModalStore, {
      showTextModal: "showTextModal",
      textModaltitle: "title",
      textModalText: "text",
    }),
    ...mapWritableState(useBuyNowModalStore, ["openBuyNowPopup", "buyNowPopType"]),
  },

  watch: {
    currentSlide() {
      this.checkDisclaimer(this.currentSlide);
    },
  },
  mounted() {
    this.getImagesWidthHeight();
    this.shiftDigital = ShiftDigitalContainer.getShiftDigitalObject();
    console.log(this.hidearrows, this.hidecontrols);
    console.log("banners data");
    console.log(this.banners);
    this.getImageRotationalBanner();

    if (window.rotatingBannerDelayTime !== null && window.rotatingBannerDelayTime !== 0) {
      // this.bannerTimmer = window.rotatingBannerDelayTime * 1000;
      // this.bannerautoplay = true;
      this.carouselConfigObject.autoplay = window.rotatingBannerDelayTime * 1000;
    }
    const couponInterval = setInterval(() => {
      if (document.querySelector(".VueCarousel-navigation-button .primaryicon-left-arrow")) {
        clearInterval(couponInterval);
        document
          .querySelector(".VueCarousel-navigation-button .primaryicon-left-arrow")
          .addEventListener("click", this.bannerBackClick);
        document
          .querySelector(".VueCarousel-navigation-button .primaryicon-right-arrow")
          .addEventListener("click", this.bannerForwardClick);
      }
    }, 200);

    if (this.render === "six-pack-component" && LayoutConstants.isGeminiTemplate()) {
      const geminiBody = document.getElementById("primary-new-body");
      if (geminiBody) {
        geminiBody.classList.add("six-pack-component-selection");
      }
    }
  },
  methods: {
    openDisclaimer(data) {
      this.textModaltitle = this.disclaimerLabel;
      this.textModalText = data;
      this.showTextModal = true;
    },
    getImagesWidthHeight() {
      if (window.location.pathname === "/") {
        if (
          typeof window.websitesDomain !== "undefined" &&
          window.websitesDomain &&
          this.applySpeedValues
        ) {
          this.deviceWidth = window.rotationalBannerWidth;
          this.deviceHeight = parseInt(window.rotationalBannerHeight);
        }
      }
    },
    getMobileImageUrl(url, banner) {
      let imageUrl = url + "&type=webp&quality=95";
      if (window.location.pathname !== "/") {
        return imageUrl;
      }
      if (banner?.rotationalBannerType?.toLowerCase() === "tdap") {
        return banner.mobileImageUrl;
      }

      try {
        if (typeof window.websitesDomain !== "undefined" && window.websitesDomain) {
          imageUrl = url + "&type=webp&quality=95";
          if (imageUrl.includes("&Width=0")) {
            imageUrl = imageUrl.replace("&Width=0", "");
          }
          if (imageUrl.includes("&Height=0")) {
            imageUrl = imageUrl.replace("&Height=0", "");
          }
        }
      } catch (e) {
        console.log(e);
      }

      return imageUrl;
    },
    checkDisclaimer() {
      let flag = false;
      let data = this.bannersdata.filter((item, index) => index === this.currentSlide);
      if (data?.[0]?.disclaimer) {
        flag = true;
      }
      return flag;
    },
    getDisclaimerLabel() {
      let data = this.bannersdata.filter((item, index) => index === this.currentSlide);
      if (data[0] && data[0].disclaimerLabel) {
        return data[0].disclaimerLabel;
      }
      return "Disclosure";
    },
    getDisclaimerPosition() {
      let data = this.bannersdata.filter((item, index) => index === this.currentSlide);
      if (data?.[0]?.disclaimerDesignType?.trim() === "top") {
        return "banner-view-details-top";
      }
      return "banner-view-details";
    },

    onDisclaimerClick() {
      let data = this.bannersdata.filter((item, index) => index === this.currentSlide);
      this.textModaltitle = data[0]?.disclaimerLabel || "Disclosure";
      this.textModalText = data[0]?.disclaimer || "No disclaimer available";
      this.showTextModal = true;
    },
    onSlideChange(slideIndex) {
      console.log("Slide changed to:", slideIndex);
      this.currentSlide = slideIndex;
      // Force reactivity to ensure disclaimer updates
      this.$forceUpdate();
    },
    onPageChange: function (val) {
      console.log(val);
      console.log(this.currentSlide);
      this.currentSlide = val;
    },

    onPageChangeEvent() {
      if (this.shiftDigital) {
        const slide = this.currentSlide ? this.currentSlide : 0;
        let carouselClick = {
          assetPosition: slide,
          assetName:
            this.bannersdata[slide] && this.bannersdata[slide].label
              ? this.bannersdata[slide].label
              : SHIFT_DIGITAL_IMAGE_ROTATIONAL_CAROUSEL_ASSET_NAME,
        };
        ShiftDigitalService.shiftDigitalCarouselClick(this.shiftDigital, carouselClick);
      }
    },

    getTarget(banner) {
      const url = banner.url;
      if (banner.redirectionType) {
        return banner.redirectionType.toLowerCase();
      }
      if (url) {
        if (url.includes("http:") || url.includes("https:")) {
          return "_blank";
        } else {
          return "_self";
        }
      }
      return "_self";
    },
    onSlideStart() {
      this.sliding = true;
      window.dispatchEvent(new Event("scroll"));
    },
    onSlideEnd() {
      this.sliding = false;
    },
    searchVehicle() {
      let url = `${window.ApiBaseUrl}/Inventory/Search?accountId=${window.accountId}&searchkeyword=${this.searchkey}&searchType=${this.searchtype}`;
      if (this.searchtype === "service") {
        url = `${window.ApiBaseUrl}/Offers/searchcoupons?accountid=${window.accountId}&campaignid=${window.campaignId}&strSearch=${this.searchkey}`;
      }
      axios.get(url).then((response) => {
        if (this.searchtype === "service") {
          this.formatService(response.data);
        } else {
          this.formatVehicles(response.data);
        }
      });
    },
    formatService(data) {
      this.vehiclesdata = [];

      data.forEach((val) => {
        let htmldata = `<a href='${window.baseUrl}/specials/servicespecials' class='d-inline-block'><div class='d-flex align-items-center'>
                                    <div class='dropdown-text'>${val.heading} ${val.subHeading}</div>
                                </div></a>`;
        this.vehiclesdata.push(htmldata);
      });
    },
    onsearchtypeclick(type) {
      this.searchkey = "";
      this.searchtype = type;
      this.vehiclesdata = [];
    },
    formatVehicles(data) {
      this.vehiclesdata = [];

      data.forEach((val) => {
        let htmldata = `<a href='${window.baseUrl}${val.link}' class='d-inline-block'><div class='d-flex align-items-center'>
                                    <img src='${val.photoURL}' class='dropdown-image'/>
                                    <div class='dropdown-text'>${val.vehcileName}</div>
                                </div></a>`;
        this.vehiclesdata.push(htmldata);
      });
    },
    sliderButton() {
      return `<em class='${
        this.nextArrowIcon
          ? this.nextArrowIcon
          : "arrow-fire primaryicon-right-arrow bgcolor-primary _mitsubishi_background_color slick-arrow"
      }' style='cursor: pointer; z-index: 1;'></em>`;
    },
    sliderleftButton() {
      return `<div><em class='${
        this.previousArrowIcon
          ? this.previousArrowIcon
          : "arrow-fire primaryicon-left-arrow slick-arrow"
      }' style='color: rgb(204, 204, 204); cursor: pointer; z-index: 1;'></em></div>`;
    },
    logTagClickEvents(label, url) {
      let tagManager = TagManagerContainer.getDealerObject();
      if (tagManager && typeof tagManager.getLinkClickEvent === "function") {
        tagManager.getLinkClickEvent(label, url);
      }
    },
    openBindEvent(banner) {
      fireTagMediaInteractionEvent({
        action: "redirect",
        mediaType: "slider",
        mediaLink: banner.url,
        mediaName: banner.altText,
      });
      fireSonicCarouselBannerClick(banner.altText, banner.imageUrl);
      this.logTagClickEvents("RotationBanner", banner.url);

      const fdEvents = ShiftDigitalContainer.getShiftDigitalObject();

      if (fdEvents && typeof fdEvents.bannerTracking === "function") {
        fdEvents.bannerTracking(banner);
      }
      if (banner && banner.category && banner.action && banner.label) {
        logGoogleBingEvent(banner.category, banner.action, banner.label, 1, banner.label);
      }
      if (banner.url === "#buynowpopup") {
        this.buyNowPopType = "new";
        this.openBuynowPopup = true;
      }
      if (this.shiftDigital) {
        const currentData = this.bannersdata[this.currentSlide];

        let assetName;
        if (currentData?.camCampaignName) {
          assetName = currentData.camCampaignName;
        } else if (currentData?.label) {
          assetName = currentData.label;
        } else {
          assetName = SHIFT_DIGITAL_IMAGE_ROTATIONAL_CAROUSEL_ASSET_NAME;
        }

        let carouselClick = {
          "carouselClick.assetPosition": this.currentSlide + 1,
          "carouselClick.assetName": assetName,
        };

        if (this.shiftDigital) {
          ShiftDigitalService.shiftDigitalCarouselClick(this.shiftDigital, carouselClick);
        }
      }

      if (banner.url?.includes("#modal")) {
        onModalLinkClick(this.getUrl(banner), this.getTarget(banner));
      } else {
        setTimeout(() => {
          window.open(this.getUrl(banner), this.getTarget(banner));
        }, 200);
      }
    },
    setPaginationActiveColor() {
      return window.primaryColor + "!important";
    },
    getBannersDataFromServer() {
      if (this.sectionid) {
        let bannerUrl = this.frameBannerAPIUrl(
          `${window.ApiBaseUrl}/Landing/GetRotationBanners?sectionId=${this.sectionid}&campaignId=${window.campaignId}&accountId=${window.accountId}`
        );
        axios.get(bannerUrl).then(this.formatResponse);
      }
    },
    async formatResponse(response) {
      try {
        let imageDummy = document.querySelector("#rotational-image-dummy");
        imageDummy && imageDummy.remove();
      } catch (e) {
        console.log(e);
      }
      console.log(response.data);
      this.searchdata = response.data.searchComponentDto;
      this.callForPriceDetails = response.data.bannerCampaignDto;
      let bannerResponse = response.data.rotationalBanners;

      let bannerList = this.filterOfferIsValid(bannerResponse);
      const isRequiredTdapBannerPresent = bannerResponse.some(
        (t) => t.rotationalBannerType.toLowerCase() === "requiredtdapbanners"
      );
      const isOptionalTdapBannerPresent = bannerResponse.some(
        (t) => t.rotationalBannerType.toLowerCase() === "optionaltdapbanners"
      );

      bannerList = this.filterEmptyBanner(bannerList);
      let tdapBanners = { requiredBanners: [], optionalBanners: [] };

      if (isRequiredTdapBannerPresent || isOptionalTdapBannerPresent) {
        tdapBanners = await this.getCamRotationalBanner(isOptionalTdapBannerPresent);
      }
      let output = [];

      bannerList.forEach((banner) => {
        if (banner.rotationalBannerType.toLowerCase() === "requiredtdapbanners") {
          output.push(...tdapBanners.requiredBanners);
        } else if (banner.rotationalBannerType.toLowerCase() === "optionaltdapbanners") {
          output.push(...tdapBanners.optionalBanners);
        } else {
          output.push(banner);
        }
      });

      this.bannersdata = output;
      this.slotIds = this.bannersdata.map((banner) => {
        return "slide-" + banner.bannerId;
      });
      this.rotationalBannersData = this.bannersdata;
      if (window.isConquestProfileEnabled && this.bannersdata?.length) {
        this.conquestProfileLogic(this.bannersdata);
      }
    },
    bannerBackClick() {
      const fdEvents = ShiftDigitalContainer.getShiftDigitalObject();
      if (fdEvents && typeof fdEvents.actionsOnHomePage === "function") {
        fdEvents.actionsOnHomePage("carousel scroll:left");
      }
      fireTagMediaInteractionEvent({
        action: "swipe left",
        mediaType: "slider",
        mediaLink: "",
        mediaName: "",
      });
    },
    bannerForwardClick() {
      const fdEvents = ShiftDigitalContainer.getShiftDigitalObject();
      if (fdEvents && typeof fdEvents.actionsOnHomePage === "function") {
        fdEvents.actionsOnHomePage("carousel scroll:right");
      }
      fireTagMediaInteractionEvent({
        action: "swipe right",
        mediaType: "slider",
        mediaLink: "",
        mediaName: "",
      });
    },
    findBannerType(banner) {
      console.log("from self");
      if (banner) {
        if (
          banner?.rotationalBannerType?.toLowerCase() === "image" ||
          banner?.rotationalBannerType?.toLowerCase() === "tdap"
        ) {
          return true;
        }
      }
      return false;
    },
    getImageRotationalBanner() {
      if (!this.banners) {
        this.getBannersDataFromServer();
      } else {
        console.log("went into else part");
        this.formatResponse({ data: this.banners.result });
      }
    },
  },
};
</script>
<style @scoped>
.banner-view-details {
  bottom: 65px;
  right: 85px;
}

.inventorynew-iframe .banner-view-details,
.inventoryvdp-iframe .banner-view-details {
  bottom: 10px !important;
}

.inventorynew-iframe .hide-controls-enabled,
.inventoryvdp-iframe .hide-controls-enabled {
  bottom: 8px !important;
}

.inventorynew-iframe .VueCarousel-pagination,
.inventoryvdp-iframe .VueCarousel-pagination {
  margin-top: unset !important;
}

.width-50 {
  width: 50%;
}

.VueCarousel-navigation-button:focus {
  outline: none !important;
}

.VueCarousel-navigation-prev {
  left: 3% !important;
}

.VueCarousel-navigation-next {
  right: 3% !important;
}

.VueCarousel-pagination {
  margin-top: -60px;
  z-index: 99;
  display: none;
}

.VueCarousel-dot[data-v-438fd353]:focus {
  outline: none;
}

.VueCarousel-dot-container button.VueCarousel-dot {
  border-radius: 50% !important;
  width: 8px !important;
  height: 8px !important;
  background-color: #cccccc !important;
  opacity: 1;
  margin: 0 5px !important;
  padding: 0px !important;
}

.VueCarousel-dot-container button.VueCarousel-dot--active {
  background-color: transparent !important;
  width: 12px !important;
  height: 12px !important;
  border: 2px solid #fff !important;
}

@media (min-width: 992px) {
  .VueCarousel-pagination {
    width: 500px !important;
    margin-left: auto;
    margin-right: auto;
  }
}

#rotaional-carousel .banner-view-details-top {
  max-width: 15%;
  right: 30px !important;
  top: 20px !important;
  bottom: unset !important;
}

@media (min-width: 992px) and (max-width: 1200px) {
  .banner-view-details {
    bottom: 65px;
    right: 85px;
  }

  .inventorynew-iframe .banner-view-details,
  .inventoryvdp-iframe .banner-view-details {
    bottom: 10px !important;
  }

  .inventorynew-iframe .hide-controls-enabled,
  .inventoryvdp-iframe .hide-controls-enabled {
    bottom: 8px !important;
  }
}

@media (max-width: 767px) {
  .rotational-banner-component {
    min-height: 10px;
  }

  .VueCarousel-navigation-prev {
    left: 10% !important;
  }

  .VueCarousel-navigation-next {
    right: 10% !important;
  }

  .banner-view-details {
    bottom: 10px;
    right: 10px;
    font-size: 8px;
  }

  #rotaional-carousel #btn-details.banner-view-details-top {
    top: -2px;
    font-size: 8px !important;
    width: 100%;
    padding: 12px 0px !important;
  }

  .inventorynew-iframe .banner-view-details,
  .inventoryvdp-iframe .banner-view-details {
    bottom: 8px !important;
    right: 10px;
  }

  .VueCarousel-pagination {
    z-index: 98;
  }
}

@media (max-width: 780px) {
  .primary-rotational-banner .VueCarousel-pagination {
    display: block;
    margin-top: 0px;
    top: unset !important;
    bottom: 10px;
    position: static !important;
  }

  .VueCarousel-navigation-prev,
  .VueCarousel-navigation-next {
    display: none;
  }

  .primary-rotational-banner .VueCarousel-pagination .VueCarousel-dot-container {
    margin-top: 0px !important;
  }
}

.rotational-banner-component .arrow-fire.primaryicon-left-arrow:active {
  background-color: inherit !important;
}

.set-aspect-ratio {
  height: auto;
}

.banner-wrapper:hover {
  text-decoration: none;
}
</style>

<style>
#rotaional-carousel section {
  text-align: left !important;
}
</style>
